<template>
  <div class="c-box" v-if="!loading">
    <loader :loading="sending" :label="getCountVariations()"/>
    <header class="c-box__heading" v-bind:class="{disabledHeader: product.status === 'cannotSend'}" @click="toggleProductInfo()">
      <span v-once>{{ product.title }}</span>
      <i v-bind:class="toggleIconClass()" class="u-floatRight icon"></i>

      <span slot="header-right">
        <span v-if="isProductStatusNotSending" class="badge u-floatRight status" v-bind:class="product.status">{{ productStatusLabel }}</span>
        <slot name="header-right"></slot>
      </span>
    </header>
    <div class="c-box__body" v-show="show && !everyVariationWithErrorOrSent">
      <div class="c-box__inner">
        <panel v-if="product" title="Informações gerais do produto">
          <div slot="header-right">
            <button :disabled="addingImage" v-bind:class="{ 'is-loading': addingImage }" @click="addingImage = true" slot="header-actions" class="hint hint--left btn btn--info" data-label="Adicionar uma imagem em uma ou mais variações">
              Adicionar Imagem
            </button>

            <modal-add-image :visible="addingImage" :variations="product.variations" :callback="uploadedImage" v-on:close="close => addingImage = close" :module="moduleUploadImageModal"/>
          </div>
          <div class="l-row">
            <form-group label="Título" :columns="12" slot="product" :error="getError('title', product.productId)" :required="true">
              <input class="form-input" type="text" v-model="product.title" :disabled="disabledInput('title')">
            </form-group>

            <form-group label="Descrição" :columns="12" slot="product" :error="getError('description', product.productId)" :required="true">
              <quill-editor  v-if="allowDescriptionHtml" :options="{ placeholder: 'Adicione a descrição do seu produto aqui' } " v-model="product.description" :disabled="disabledInput('description')"/>
              <textarea v-else class="form-textarea" rows="8" :options="{ placeholder: 'Adicione a descrição do seu produto aqui' } " v-model="product.description" :disabled="disabledInput('description')">
            </textarea>
              <small v-if="maxDescriptionLengthDI !== null" class="form-help" v-bind:class="descriptionLength">{{ getDescriptionLengthLabel() }}</small>
            </form-group>

            <form-group v-if="!disabledFormInput" label="Marca" :columns="3" slot="product" :error="getError('brand', product.productId)" :required="true">
              <input class="form-input" type="text" v-model="product.brand" v-if="!$slots.brands" :disabled="disabledInput('description')">
              <slot name="brands"/>
            </form-group>

            <slot/>

          </div>
        </panel>

        <div class="divider">
          <span>Informações das variações do produto</span>
        </div>

        <div class="l-row vertical-flex">
          <div class="l-col-12@md" v-for="variation in product.variations" :key="variation">
            <component :is="marketplaceVariationProvide" ref="product.variations" :fromModule="fromModule" :toModule="toModule" :variation="variation" :account="account" @change="updateProductStatus"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { upperFirst } from 'lodash'
  import { mapGetters } from 'vuex'
  import Loader from '@/components/template/Loader'
  import Panel from '@/components/template/Panel'
  import FormGroup from '@/components/template/FormGroup'
  import { quillEditor } from 'vue-quill-editor'
  import MarketplaceProvideVariationSkyhub from '@/components/marketplace/skyhub/provide/Variation'
  import MarketplaceProvideVariationShopee from '@/components/marketplace/shopee/provide/Variation'
  import MarketplaceProvideVariationNetshoes from '@/components/marketplace/netshoes/provide/Variation'
  import MarketplaceProvideVariationColombo from '@/components/marketplace/colombo/provide/Variation'
  import MarketplaceProvideVariationIntegracommerce from '@/components/marketplace/integracommerce/provide/Variation'
  import MarketplaceProvideVariationCnova from '@/components/marketplace/cnova/provide/Variation'
  import MarketplaceProvideVariationLeroy from '@/components/marketplace/leroy/provide/Variation'
  import MarketplaceProvideVariationCarrefour from '@/components/marketplace/carrefour/provide/Variation'
  import MarketplaceProvideVariationWebcontinental from '@/components/marketplace/webcontinental/provide/Variation'
  import MarketplaceProvideVariationWalmart from '@/components/marketplace/walmart/provide/Variation'
  import MarketplaceProvideVariationMadeira from '@/components/marketplace/madeira/provide/Variation'
  import MarketplaceProvideVariationGfg from '@/components/marketplace/gfg/provide/Variation'
  import MarketplaceProvideVariationZoom from '@/components/marketplace/zoom/provide/Variation'
  import MarketplaceProvideVariationCentauro from '@/components/marketplace/centauro/provide/Variation'
  import MarketplaceProvideVariationAmazon from '@/components/marketplace/amazon/provide/Variation'
  import MarketplaceProvideVariationRicardoEletro from '@/components/marketplace/ricardoEletro/provide/Variation'
  import MarketplaceProvideVariationRenner from '@/components/marketplace/renner/provide/Variation'
  import ModalAddImage from '@/components/marketplace/shared/provide/ModalAddImage'

  export default {
    inject: ['maxDescriptionLengthDI', 'moduleDI', 'allowDescriptionHtml'],
    data: () => ({
      show: false,
      isProductStatusNotSending: false,
      productStatusLabel: '',
      addingImage: false,
      disabledFormInput: false
    }),
    props: {
      product: {
        type: Object,
        required: true
      },
      fromModule: {
        type: Object,
        required: true
      },
      toModule: {
        type: Object,
        required: true
      },
      loading: {
        type: Boolean,
        default: false
      },
      disabledInputList: {
        type: Array,
        default: () => []
      },
      account: {
        type: Object,
        required: false,
        default: null
      }
    },
    mounted () {
      this.disabledFormInput = this.$parent.disabledFormInput

      if (!this.allowDescriptionHtml) {
        this.removeHtml()
      }
      this.formatDescription()
      if (this.product.withoutCategory === true) {
        this.isProductStatusNotSending = true
        this.productStatusLabel = 'Produto sem categoria'
      }
    },
    methods: {
      toggleProductInfo () {
        if (this.product.status === 'sent' || this.product.status === 'error' || this.product.status === 'cannotSend') {
          return false
        }

        this.show = !this.show
      },
      toggleIconClass () {
        return {
          'icon-circle-up': this.show,
          'icon-circle-down': !this.show || this.everyVariationWithErrorOrSent
        }
      },
      getDescriptionLengthLabel () {
        return `${this.product.description.length}/${this.maxDescriptionLengthDI}`
      },
      getCountVariations () {
        const selectedVariations = this.product.variations
          .filter(variation => variation.selected)

        const sentVariations = selectedVariations
          .filter(variation => variation.status !== 'sending')
          .length

        return `${sentVariations}/${selectedVariations.length} variações enviadas`
      },
      statusSendIconClass () {
        return {
          'icon-checkmark t-success': this.product.status === 'sent',
          'icon-cross t-error': this.product.status === 'error',
          'icon-cross t-warning': this.product.status === 'to-fix'
        }
      },
      getClassStatusVariation (variation) {
        return {
          'success': variation.status === 'sent',
          'error': variation.status === 'error'
        }
      },
      async updateProductStatus () {
        const totalVariationsCannotSend = this.product.variations.filter(variation => variation.status === 'cannotSend')
        if (this.product.variations.length === totalVariationsCannotSend.length) {
          this.product.status = 'cannotSend'
        }

        this.isProductStatusNotSending = this.product.status !== 'sending' && this.product.status

        if (this.product.status) {
          this.productStatusLabel = this.$t(`${this.product.status}.label`)
        }
        if (this.product.withoutCategory === true) {
          this.isProductStatusNotSending = true
          this.productStatusLabel = 'Produto sem categoria'
        }
      },
      removeHtml () {
        const doc = new DOMParser().parseFromString(this.product.description, 'text/html')
        doc.querySelectorAll('li').forEach(li => {
          li.textContent = '  • ' + li.textContent
        })
        let text = ''
        const walker = doc.createTreeWalker(doc.body, 4 | 1)
        let node = walker.nextNode()
        while (node) {
          if (node.nodeType === 3) {
            text += node.textContent
          } else if (node.nodeType === 1 && /^(P|DIV|H[1-6]|LI|BR)$/.test(node.tagName)) {
            text += '\n'
          }
          node = walker.nextNode()
        }

        text = text
          .replace(/\r\n/g, '\n')
          .replace(/\r/g, '\n')
          .replace(/\n{3,}/g, '\n\n')
          .trim()

        this.product.description = text
      },
      formatDescription () {
        let formattedDescription = this.product.description
          .replaceAll('<p><br></p><p><br></p>', '<p></p>')
          .replaceAll('<p><br></p><p><br></p><p><br></p>', '<p></p>')
          .replaceAll('<p><br></p><p><br></p><p><br></p><p><br></p>', '<p></p>')
          .replaceAll('<p><br></p><p><br></p><p><br></p><p><br></p><p><br></p>', '<p></p>')

        this.product.description = formattedDescription
      },
      uploadedImage (urls, variations) {
        for (let i in variations) {
          const sku = variations[i].sku
          const variation = this.product.variations.find(variation => variation.sku === sku)

          if (variation === undefined) {
            continue
          }

          for (let j in urls) {
            variation.images.push(urls[j])
          }
        }

        variations.splice(0, variations.length)
      },
      disabledInput (input) {
        if (!this.disabledInputList.length) {
          return false
        }

        return this.disabledInputList.indexOf(input) !== -1
      }
    },
    computed: {
      ...mapGetters('errors', [
        'getError'
      ]),
      marketplaceVariationProvide () {
        return `MarketplaceProvideVariation${upperFirst(this.moduleDI.identifier)}`
      },
      sending () {
        return !!this.product.variations
          .filter(variation => variation.status === 'sending').length
      },
      everyVariationWithErrorOrSent () {
        return this.product.variations.every(variation => variation.status === 'error' || variation.status === 'sent')
      },
      descriptionLength () {
        return {
          't-success': this.product.description.length <= this.maxDescriptionLengthDI,
          't-error': this.product.description.length > this.maxDescriptionLengthDI
        }
      },
      moduleUploadImageModal () {
        return {
          type: this.toModule.type,
          identifier: this.toModule.identifier
        }
      }
    },
    components: {
      Loader,
      Panel,
      FormGroup,
      quillEditor,
      MarketplaceProvideVariationSkyhub,
      MarketplaceProvideVariationShopee,
      MarketplaceProvideVariationNetshoes,
      MarketplaceProvideVariationColombo,
      MarketplaceProvideVariationIntegracommerce,
      MarketplaceProvideVariationCnova,
      MarketplaceProvideVariationLeroy,
      MarketplaceProvideVariationCarrefour,
      MarketplaceProvideVariationWebcontinental,
      MarketplaceProvideVariationWalmart,
      MarketplaceProvideVariationMadeira,
      MarketplaceProvideVariationGfg,
      MarketplaceProvideVariationZoom,
      MarketplaceProvideVariationCentauro,
      MarketplaceProvideVariationAmazon,
      MarketplaceProvideVariationRicardoEletro,
      MarketplaceProvideVariationRenner,
      ModalAddImage
    }
  }
</script>

<style lang="sass" scoped>
  .c-box
    margin-bottom: 16px

  .c-box__body
    background: #d9edf7

  .c-box__heading
    cursor: pointer
    height: 50px
    line-height: 2
    font-size: 15px
    color: #31708f
    background-color: #d9edf7
    border-color: #bde2fb

  .icon-circle-down, .icon-circle-up
    font-size: 30px

  .c-box__body
    border-color: #bde2fb

  .divider
    margin-bottom: 16px

  .status
    margin-right: 20px
    margin-top: 4px

  .disabledHeader
    cursor: not-allowed
    background-color:  #E7E7E7
    border-color: #D3D3D3

    .icon
      opacity: 0.3
</style>



// WEBPACK FOOTER //
// Product.vue?2da855fd